
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/phone",
      function () {
        return require("private-next-pages/shop/phone/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/phone"])
      });
    }
  